import styled from "styled-components";

export const BlockPageWrapper = styled.div`
  padding-bottom: 25px;
`;
